module.exports = __webpack_public_path__ + "img/oilGrey.0a76421c.svg";